module.exports = __webpack_public_path__ + "static/img/img6.b58c7c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img6.png
// module id = P0g5
// module chunks = 1